export default __webpack_public_path__ + "static/media/logo-mini.d0318e3b.png";